import { useState, useCallback } from "react";

/**
 * از ارسال چندباره فرم جلوگیری می‌کند.
 * وقتی درخواست در حال پردازش است، دکمه غیرفعال می‌شود.
 *
 * مثال استفاده:
 *   const { submitting, submit } = useSubmit();
 *   <button disabled={submitting} onClick={() => submit(handleAdd)}>ثبت</button>
 */
export function useSubmit() {
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(async (fn: () => Promise<void> | void) => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await fn();
    } finally {
      setSubmitting(false);
    }
  }, [submitting]);

  return { submitting, submit };
}